export default __webpack_public_path__ + "static/media/cern-extrabold-italic.9a4a56a9.woff";